/**
 * Max len of combined first/last names from UPS (has lowest allowed char count)
 * https://www.serviceobjects.com/blog/character-limits-in-address-lines-for-usps-ups-and-fedex/
 */
export const FULL_NAME_MAX_LEN = 35;

// Very basic regex defining *unsupported* characters in first, middle & last names
export const BASIC_NAME_EXCLUSIONARY_REGEX = /[!@#$%()[\]^*:"";/,]/g;
